module.exports = __webpack_public_path__ + "img/IMAGE 2.1d7fb148.png";